import { render, staticRenderFns } from "./costs.vue?vue&type=template&id=1aab7289&scoped=true"
import script from "./costs.vue?vue&type=script&lang=js"
export * from "./costs.vue?vue&type=script&lang=js"
import style0 from "./costs.vue?vue&type=style&index=0&id=1aab7289&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aab7289",
  null
  
)

export default component.exports